import _ from 'underscore';

import SEGMENT_TRACKING_EVENTS from 'constants/segmentEvents';

function CustomerDatabaseCtrl($scope, $rootScope, $state, organizationService, customerService, alertService, ERROR_MESSAGES, modalService, sdkUtils, loggerService, venueService, TRACKING_EVENT_CATEGORIES, analyticsService, $q, reportService) { //eslint-disable-line
  const currentUserOrganization = organizationService.getCurrentOrganization();

  _initScope();

  _getVenues()
    .then(_getCustomers)
    .then(() => {
      $scope.loading = false;
    });

  function _initScope() {
    $scope.loading = true;
    $scope.customers = [];
    $scope.customerTotalCount = 0;

    $scope.customerSearchForm = {};

    /**
     * @desc jQuery Data Table options
     */
    $scope.customerListDataTableOptions = {
      paginationType: 'full_numbers',
      displayLength: 50,
      order: [
        [8, 'desc']
      ]
    };

    $scope.customerDataTableInstance = {};

    $scope.showMergeCustomersModal = _showMergeCustomersModal;
    $scope.getCustomers = function() {
      $scope.searching = true;

      _getCustomers()
        .finally(() => {
          $scope.searching = false;
        });
    };

    $scope.deleteCustomer = _deleteCustomer;
    $scope.clearFilters = _clearFilters;
    $scope.exportData = _exportData;
    $scope.selectAllCustomers = _selectAllCustomers;
    $scope.selectCustomer = _selectCustomer;

    $scope.selectAllCustomersForm = {
      selected: false
    };

    // whether at least one customer is selected
    $scope.isACustomerSelected = false;
  }

  function _selectAllCustomers($event) {
    if ($event) $event.preventDefault();

    const selectedCustomer = _.findWhere($scope.customers, {
      selected: true
    });

    if (!selectedCustomer) {
      _.each($scope.customers, customer => {
        customer.selected = true;
      });
      $scope.isACustomerSelected = true;
    } else {
      _.each($scope.customers, customer => {
        customer.selected = false;
      });
      $scope.isACustomerSelected = false;
    }
  }

  function _selectCustomer() {
    $scope.isACustomerSelected = _.findIndex($scope.customers, {
      selected: true
    }) > -1;
  }

  function _clearFilters($event) {
    if ($event) $event.preventDefault();

    if ($scope.customerSearchForm) {
      $scope.customerSearchForm.name = null;
      $scope.customerSearchForm.showTags = false;
      $scope.customerSearchForm.showGender = false;
      $scope.customerSearchForm.showContactInfo = false;
      $scope.customerSearchForm.showBirthday = false;

      // total spend
      $scope.customerSearchForm.showTotalSpend = false;
      $scope.customerSearchForm.showMinimumTotalSpend = false;
      $scope.customerSearchForm.showMaximumTotalSpend = false;
      $scope.customerSearchForm.maximumTotalSpend = null;
      $scope.customerSearchForm.minimumTotalSpend = null;

      // average table minimum
      $scope.customerSearchForm.showAverageTableMinimum = false;
      $scope.customerSearchForm.showMinimumAverageTableMinimum = false;
      $scope.customerSearchForm.showMaximumAverageTableMinimum = false;
      $scope.customerSearchForm.maximumAverageTableMinimum = null;
      $scope.customerSearchForm.minimumAverageTableMinimum = null;
    }

    $scope.filtersApplied = false;

    $scope.searching = true;

    _getCustomers()
      .finally(() => {
        $scope.searching = false;
      });
  }

  function _exportData($event) {
    if ($event) $event.preventDefault();

    const selectedCustomerIds = $scope.customers.reduce((customerIds, customer) => {
      if (customer.selected) customerIds.push(customer.id);
      return customerIds;
    }, []);

    const options = {
      fileType: 'CSV',
      organizationId: currentUserOrganization.id,
      reportType: 'TLPRO_CUSTOMER_DUMP'
    };

    if (selectedCustomerIds.length) {
      options.customerId = selectedCustomerIds;
    }

    return reportService.create(options);
  }

  function _showMergeCustomersModal($event) {
    if ($event) $event.preventDefault();

    const selectedCustomers = _.where($scope.customers, {
      selected: true
    });

    if (!selectedCustomers || !selectedCustomers.length || selectedCustomers.length < 2) {
      alertService.error('Must select at least 2 customers to merge');

      return;
    }

    if (!selectedCustomers || !selectedCustomers.length || selectedCustomers.length > 10) {
      alertService.error('Cannot select more than 10 customers to merge');

      return;
    }

    //because we have to send up a venueId to the API (because customers have to be accessed by org-relationships)
    //we need a venueId for the organizaion the user is in
    //so find the first venue the user is in, that is also in the organizaiton they are in (excluded any org-relationship venues)
    const firstOrganizationVenue = _.findWhere($scope.venues, {
      organization: currentUserOrganization.id
    });

    modalService.mergeCustomers({
        customers: selectedCustomers,
        venueId: firstOrganizationVenue.id
      })
      .then(result => {
        if (!result || !result.customer) return;

        const foundCustomer = _.findWhere($scope.customers, {
          id: result.customer.id
        });

        if (foundCustomer) {
          _.extend(foundCustomer, result.customer);

          foundCustomer.selected = false; //uncheck the customer
        }

        $scope.customers = _.reject($scope.customers, customer => _.contains(result.deletedCustomerIds, customer.id));

        alertService.success('Customers merged');
      })
      .catch(() => {
        alertService.error('There was an error merging customers');
      });
  }

  /**
   * @return {Promise}
   */
  function _getCustomers($event) {
    if ($event) $event.preventDefault();

    let query = {};

    if ($scope.customerSearchForm) {
      query = _buildSearchQuery();
      const queryError = validateSearchQuery(query);
      if (queryError) {
        alertService.error(queryError);
        return $q.resolve(null);
      }
    }

    //because we have to send up a venueId to the API (because customers have to be accessed by org-relationships)
    //we need a venueId for the organizaion the user is in
    //so find the first venue the user is in, that is also in the organizaiton they are in (excluded any org-relationship venues)
    const firstOrganizationVenue = _.findWhere($scope.venues, {
      organization: currentUserOrganization.id
    });

    if (!firstOrganizationVenue) {
      return $q.resolve(null);
    }

    return customerService.queryByOrganizationId(currentUserOrganization.id, {
        venueId: firstOrganizationVenue ? firstOrganizationVenue.id : null,
        query: JSON.stringify(query),
        sort: '-stats.totalSpend',
        limit: 250
      })
      .then(({
        data,
        totalCount
      }) => {
        $scope.totalCount = totalCount;
        $scope.customers = addFieldsToCustomers(data);
      })
      .catch(response => {
        const errorMsg = sdkUtils.getErrorFromResponse(response);

        if (errorMsg) loggerService.error(errorMsg);

        alertService.fatalError(ERROR_MESSAGES.ERROR_GETTING_ORGANIZATION_CUSTOMERS);
      });
  }

  function _getVenues() {
    return venueService.listByOrganizationId(currentUserOrganization.id, {
        fields: [
          'name',
          'location',
          'schedule',
          'slug'
        ].join(',')
      })
      .then(venues => {
        $scope.venues = venues;
      })
      .catch(error => {
        alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  }

  function _deleteCustomer(customer, $event) {
    if (!customer) throw new Error('customer is required');
    if ($event) $event.preventDefault();

    modalService.confirmation({
        modalHeader: `Delete Customer ${customer.name}`,
        modalMessage: 'Are you sure you want to delete this customer?',
        confirmBtnTxt: 'Delete Customer',
        confirmingBtnTxt: 'Deleting...',
        size: 'sm'
      })
      .then(result => {
        if (result && result.confirm) {
          customerService.deleteByIdAndOrganizationId(customer.id, currentUserOrganization.id)
            .then(() => {
              const index = $scope.customers.indexOf(customer);

              $scope.customers.splice(index, 1);

              alertService.success('Customer deleted');
            })
            .catch(response => {
              alertService.error(sdkUtils.getErrorFromResponse(response));
            })
            .finally(() => {
              result.modalInstance.close();
            });
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  function _buildSearchQuery() {
    const query = {};

    const andClauses = [];
    const orClauses = [];

    if ($scope.customerSearchForm.name) {
      _trackCustomerFilter(SEGMENT_TRACKING_EVENTS.FILTERED_CUSTOMERS_BY_NAME);

      $scope.filtersApplied = true;
      const term = $scope.customerSearchForm.name || '';

      orClauses.push({
        name: {
          $regex: term,
          $options: 'i'
        }
      });

      orClauses.push({
        email: {
          $regex: term,
          $options: 'i'
        }
      });

      orClauses.push({
        phone: {
          $regex: term,
          $options: 'i'
        }
      });
    }

    if ($scope.customerSearchForm.showVenues && $scope.customerSearchForm.venues) {
      $scope.filtersApplied = true;

      query.venues = $scope.customerSearchForm.venues;
    }

    if ($scope.customerSearchForm.showTags && $scope.customerSearchForm.tags) {
      _trackCustomerFilter(SEGMENT_TRACKING_EVENTS.FILTERED_CUSTOMERS_BY_TAGS);

      $scope.filtersApplied = true;

      const tags = $scope.customerSearchForm.tags.split(',').map(tag => tag.trim());

      query.tags = {
        $in: tags
      };
    }

    if ($scope.customerSearchForm.showGender && $scope.customerSearchForm.gender) {
      _trackCustomerFilter(SEGMENT_TRACKING_EVENTS.FILTERED_CUSTOMERS_BY_GENDER);

      $scope.filtersApplied = true;

      query.gender = $scope.customerSearchForm.gender;
    }

    if ($scope.customerSearchForm.showContactInfo && $scope.customerSearchForm.contactInformation) {
      _trackCustomerFilter(SEGMENT_TRACKING_EVENTS.FILTERED_CUSTOMERS_BY_CONTACT_INFO);

      $scope.filtersApplied = true;

      if ($scope.customerSearchForm.contactInformation === 'phone') {
        query.phone = {
          $exists: true,
          $ne: null
        };
      }

      if ($scope.customerSearchForm.contactInformation === 'email' || $scope.customerSearchForm.contactInformation === 'phone-email') {
        query.email = {
          $exists: true,
          $ne: null
        };
      }

      if ($scope.customerSearchForm.contactInformation === 'phone-email') {
        andClauses.push({
          phone: {
            $exists: true,
            $ne: null
          }
        });
        andClauses.push({
          email: {
            $exists: true,
            $ne: null
          }
        });
      }

      if ($scope.customerSearchForm.contactInformation === 'no-phone') {
        query.phone = {
          $exists: false
        };
      }

      if ($scope.customerSearchForm.contactInformation === 'no-email') {
        query.email = {
          $exists: false
        };
      }
    }

    if ($scope.customerSearchForm.showGender && $scope.customerSearchForm.gender) {
      _trackCustomerFilter(SEGMENT_TRACKING_EVENTS.FILTERED_CUSTOMERS_BY_GENDER);

      $scope.filtersApplied = true;
      query.gender = $scope.customerSearchForm.gender;
    }

    if ($scope.customerSearchForm.showBirthday && $scope.customerSearchForm.birthday) {
      _trackCustomerFilter(SEGMENT_TRACKING_EVENTS.FILTERED_CUSTOMERS_BY_BIRTHDAY);

      $scope.filtersApplied = true;
      query.birthdayMonth = $scope.customerSearchForm.birthday;
    }

    // Total Spend
    if ($scope.customerSearchForm.showTotalSpend) {
      const totalSpendQuery = {};

      if ($scope.customerSearchForm.showMinimumTotalSpend && $scope.customerSearchForm.minimumTotalSpend) {
        $scope.filtersApplied = true;
        totalSpendQuery.$gte = $scope.customerSearchForm.minimumTotalSpend;
      }

      if ($scope.customerSearchForm.showMaximumTotalSpend && $scope.customerSearchForm.maximumTotalSpend) {
        $scope.filtersApplied = true;
        totalSpendQuery.$lte = $scope.customerSearchForm.maximumTotalSpend;
      }

      if (!_.isEmpty(totalSpendQuery)) {
        query.statsTotalSpend = totalSpendQuery;
      }

    }

    // Average Table Minimum
    if ($scope.customerSearchForm.showAverageTableMinimum) {
      const averageTableMinimumQuery = {};

      if ($scope.customerSearchForm.showMinimumAverageTableMinimum && $scope.customerSearchForm.minimumAverageTableMinimum) {
        $scope.filtersApplied = true;
        averageTableMinimumQuery.$gte = $scope.customerSearchForm.minimumAverageTableMinimum;
      }

      if ($scope.customerSearchForm.showMaximumAverageTableMinimum && $scope.customerSearchForm.maximumAverageTableMinimum) {
        $scope.filtersApplied = true;
        averageTableMinimumQuery.$lte = $scope.customerSearchForm.maximumAverageTableMinimum;
      }

      if (!_.isEmpty(averageTableMinimumQuery)) {
        query.statsAverageTableMinimum = averageTableMinimumQuery;
      }

    }

    if (andClauses.length) query.$and = andClauses;

    if (orClauses.length) query.$or = orClauses;

    return query;
  }

  function validateSearchQuery(query) {
    if (query.statsTotalSpend) {
      if (query.statsTotalSpend.$lte && _.isNaN(Number(query.statsTotalSpend.$lte))) return 'Total Spend Maximum must be a valid number';
      if (query.statsTotalSpend.$gte && _.isNaN(Number(query.statsTotalSpend.$gte))) return 'Total Spend Minimum must be a valid number';
      if (query.statsTotalSpend.$gte && query.statsTotalSpend.$lte && Number(query.statsTotalSpend.$lte) <= Number(query.statsTotalSpend.$gte)) {
        return 'Total Spend Minimum must be less than Total Spend Maximum';
      }
    }

    return '';
  }

  function _trackCustomerFilter(action) {
    analyticsService.trackEvent(action, {
      category: TRACKING_EVENT_CATEGORIES.CUSTOMERS
    });
  }

  function addFieldsToCustomers(customers) {
    // add initials field
    customers.forEach(customer => {
      customer.initials = getCustomerInitials(customer);
    });

    return customers;
  }

  function getCustomerInitials(customer) {
    return (customer.name || '')
      .replace(/[^a-zA-Z\s]/g, '')
      .split(/\s/)
      .map(token => {
        return token.length > 0 ? token.substring(0, 1).toUpperCase() : '';
      })
      .join('')
      .substring(0, 4);
  }
}

CustomerDatabaseCtrl.$inject = [
  '$scope',
  '$rootScope',
  '$state',
  'organizationService',
  'jsSdk.customer',
  'alertService',
  'ERROR_MESSAGES',
  'modalService',
  'jsSdk.utils',
  'loggerService',
  'jsSdk.venue',
  'TRACKING_EVENT_CATEGORIES',
  'analyticsService',
  '$q',
  'reportService'
];

export default CustomerDatabaseCtrl;



// WEBPACK FOOTER //
// ./src/components/customerDatabase/customerDatabaseCtrl.js